import { useEffect, useState } from "react";
import { NavbarHome } from "../../../components/navigation/NavbarHome";
import { TimelineCore } from "../../../components/timeline/timelineCore";
import { FunnelService } from "../../../services/funnel/funnel.service";
import { useSearchParams } from "react-router-dom";
import { variablesGlobales } from "../../../configs/variables";



export function OperationFunnelDetail(props) {

    const [searchParams] = useSearchParams();
    const [funnnelData, setFunnelData] = useState(null);
    const [timelineData, setTimelineData] = useState(null);
    const [isLoading, setIsLoading] = useState(true);
    const [funnelEmpty, setFunnelEmpty] = useState(false);

    const operationId = searchParams.get('operationId'); //operationId
    const creditId = searchParams.get('creditId'); //operationId
    const funnelId = searchParams.get('funnelId'); //operationId

    const getFunnel = async () => {
        try {
            let url;
            let urlByOperationId = `${variablesGlobales.urlServiceBackend}/api/v1/funnel/getByOperationId?operationId=${operationId}`;
            let urlByCreditId = `${variablesGlobales.urlServiceBackend}/api/v1/funnel/getByCreditId?creditId=${creditId}`;
            let urlByFunnelId = `${variablesGlobales.urlServiceBackend}/api/v1/funnel/getByFunnelId?funnelId=${funnelId}`;
            if(operationId){
                url = urlByOperationId;
            }else if(creditId){
                url = urlByCreditId;
            }else if(funnelId){
                url = urlByFunnelId;
            }
            const { message } = await FunnelService.getFunnel(url)
            return message?.data ?? {};
        } catch (error) {
            console.log(error);
            return {}
        }
    }

    useEffect(() => {
        const loadfunnel = async () => {
            let info = await getFunnel();
            return info;
        };

        loadfunnel()
            .then((funnel) => {
                if (Object.keys(funnel).length > 0) {
                    console.log(funnel);
                    setFunnelData(funnel);
                    setTimelineData(funnel['timeline']);
                    setIsLoading(false);
                } else {
                    setFunnelEmpty(true);
                    setIsLoading(false);
                }
            })
            .catch(e => console.log(e))
    }, []);

    if (isLoading) {
        return (
            <>
                <div>
                    <NavbarHome current1={true} />
                    <div className="flex bg-purpleLight text-tdark min-h-screen flex-col justify-center sm:px-6 lg:px-8  tracking-tight ">
                        <div className="flex justify-center">
                            <h3 className="font-bold text-3xl">Cargando...</h3>
                        </div>

                    </div>
                </div>
            </>
        );
    }

    return (
        <>
            <div>
                <NavbarHome current1={true} />
                <div className="flex  bg-purpleLight text-tdark min-h-screen flex-col justify-center sm:px-6  tracking-tight ">
                    <div className="flex justify-center">
                        {
                            operationId ? <h3 className="font-bold text-3xl">Api Funnel solicitud de crédito</h3>
                            :
                            <h3 className="font-bold text-3xl">Direct Funnel solicitud de crédito</h3>
                        }
                        
                    </div>
                    {

                        funnelEmpty ? (

                            <div style={{ display: 'flex', flexDirection: 'column', justifyContent: 'center', alignContent: 'center', alignItems: "center" }} className=" pt-2">
                                <img className="pt-5 pb-4" src="/svg/undraw_no_data_re_kwbl.svg" width={100} height={100} alt="not found" />
                                <span className="pt-4 pb-4 text-1xl">No se encontró información.</span>
                            </div>
                        )
                            :

                            (<div className="py-3 mt-2" style={{ overflow: 'auto', height: '60vh'/* , width: '95vw'  */}}>
                                <TimelineCore timelineData={timelineData}></TimelineCore>
                            </div>
                            )
                    }

                </div >
            </div >
        </>
    )

}